import React, 
       { useState, 
         useEffect, 
         useRef,
         useCallback                 }      from "react";
import { useLoader                   }      from "components/Covers/loadingCover";
import { useInfoMsgModal}                   from "components/Covers/infoMessageModal";
import { useToastMessage             }      from "components/Covers/toastMessage";
import { InputGeneral                }      from "components/Field/field";
import { DatePicker,
         DateTimePicker,
         DateToIsoString,
         DateFromIsoString,
         InitDateToIsoString,
         InitDateFromIsoString,
         FinDateToIsoString,
         FinDateFromIsoString,
         setDefaultInitDate,
         setDefaultFinalDate,
         compareInitFinDate }               from "components/Date/date";
import  MainStyle                           from "components/UI/main.module.scss";
import { useNavigate                  }     from "react-router-dom";
import { Select                       }     from "antd";
import { DefaultLoadingLogo,
         Heimdall,
         GetLabel,
         SetLastFeature               }     from "Utilities/utils";
import { getData, 
         getFilterMeta,               }     from "./Report_3_Service";

// #region Object Template
let blank_search_param_obj = {
    DT_INIT           : DateToIsoString(setDefaultInitDate()),
    DT_FN             : DateToIsoString(setDefaultFinalDate()),
    SCHOOL_IDS        : [],
    AREA_IDS          : [],
    PROGRAM_IDS       : [],
    CLASSES_IDS       : [],
    CLIENT_IDS        : [],
    ACADEMIC_AREA_IDS : [],
    USER_IDS          : [],
    QUESTION_IDS      : [],
};
let blank_meta_param_obj = {
    SCHOOL_LIST       : [],
    AREA_LIST         : [],
    PROGRAM_LIST      : [],
    CLASS_LIST        : [],
    CLIENT_LIST       : [],
    ACADEMIC_AREA_LIST: [],
    USER_LIST         : [],
    QUESTION_LIST     : [],
};
let appLang = null;
// #endregion

// #region Layout Helppers
const DropdownList = ({
    className,
    style,
    onChange,
    onSearch,
    listOfItems,
    placeholder,
    id,
    name,
    defaultValue,
    title,
    popupClassName,
    value,
  }) => {
    return (
      <Select
        showSearch
        allowClear
        id={id}
        name={name}
        value={value} // use directly from props
        placeholder={placeholder}
        className={className}
        style={style}
        title={title}
        popupClassName={popupClassName}
        options={listOfItems}
        optionFilterProp="label"
        filterOption={(input, option) =>
          (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
        }
        onChange={(val, option) => {
          onChange?.(val, option); // lift change to parent
        }}
        onSearch={(val) => {
          onSearch?.(val);
        }}
        notFoundContent={null}
      />
    );
};
const DefaultPadding = () =>{
    return(<div className={MainStyle.py_3}/>);
};
const DivisionBlock = () => {
    return(
        <>
            <div className={[MainStyle.py_2].join(" ")}>
                <div className={MainStyle.row}>
                    <div className={[MainStyle.col_lg, MainStyle.border_bottom].join(" ")}/>
                </div>
            </div>
        </>
    );
};
//#endregion

// #region Filter Data
const FilterBtnRemoveItem = React.memo(({clickAction}) => {
    return (
        <div 
            onClick={clickAction}
            className={[MainStyle.py_1].join(" ")}
        >
            <div className={[MainStyle.d_flex].join(" ")}>
                <svg
                    xmlns="http://www.w3.org/2000/svg" 
                    viewBox="0 0 384 512"
                    style={{width: '0.8rem', height: '0.8rem'}}
                    className={[MainStyle.close_icon].join(" ")} 
                >
                    <path d="M376.6 84.5c11.3-13.6 9.5-33.8-4.1-45.1s-33.8-9.5-45.1 4.1L192 206 56.6 43.5C45.3 29.9 25.1 28.1 11.5 39.4S-3.9 70.9 7.4 84.5L150.3 256 7.4 427.5c-11.3 13.6-9.5 33.8 4.1 45.1s33.8 9.5 45.1-4.1L192 306 327.4 468.5c11.3 13.6 31.5 15.4 45.1 4.1s15.4-31.5 4.1-45.1L233.7 256 376.6 84.5z"/>
                </svg>
            </div>
        </div>
    );
});
const FilterSchoolList = React.memo(({...other}) => {
    const { searchMetaParam,
            searchParam,
            setSearchParam   } = other;
    
    function getLabelValue(d) {
        const found = searchMetaParam.SCHOOL_LIST.find((item) => item.SCHOOL_ID === d);
        return found ? found.SCHOOL_DESC : null;
    }
    const RemoveItem = (d) => {
        setSearchParam((prevState) => {
            const newList = prevState.SCHOOL_IDS.filter(item => item !== d);
            return {
                ...prevState,
                SCHOOL_IDS: newList,
            };
        });
    };
    useEffect(() => {},[searchParam, setSearchParam]);

    return (
        <>                                        
            {searchParam?.SCHOOL_IDS?.map((item, i) => {
                    return (
                        <div key={`school_list_${item}${i}`} className={[MainStyle.d_flex, MainStyle.align_items_center, MainStyle.rounded, MainStyle.filter_param_item_border, MainStyle.my_2].join(" ")}>
                            <div className={[MainStyle.mx_2].join(" ")}>
                                <FilterBtnRemoveItem clickAction={() => RemoveItem(item)} />
                            </div>
                            <div className={[].join(" ")}>
                                <span className={[MainStyle.text_body, MainStyle.fs_8].join(" ")}>
                                    {getLabelValue(item)}
                                </span>
                            </div>
                        </div>
                    )
                }
            )}
        </>
    );
});
const FilterAreaList = React.memo(({...other}) => {
    const { searchMetaParam,
            searchParam,
            setSearchParam   } = other;
    
    function getLabelValue(d) {
        const found = searchMetaParam.AREA_LIST.find((item) => item.AREA_ID === d);
        return found ? found.AREA_DESC : null;
    }
    const RemoveItem = (d) => {
        setSearchParam((prevState) => {
            const newList = prevState.AREA_IDS.filter(item => item !== d);
            return {
                ...prevState,
                AREA_IDS: newList,
            };
        });
    };
    useEffect(() => {},[searchParam, setSearchParam]);

    return (
        <>                                        
            {searchParam?.AREA_IDS?.map((item, i) => {
                    return (
                        <div key={`area_list_${item}${i}`} className={[MainStyle.d_flex, MainStyle.align_items_center, MainStyle.rounded, MainStyle.filter_param_item_border, MainStyle.my_2].join(" ")}>
                            <div className={[MainStyle.mx_2].join(" ")}>
                                <FilterBtnRemoveItem clickAction={() => RemoveItem(item)} />
                            </div>
                            <div className={[].join(" ")}>
                                <span className={[MainStyle.text_body, MainStyle.fs_8].join(" ")}>
                                    {getLabelValue(item)}
                                </span>
                            </div>
                        </div>
                    )
                }
            )}
        </>
    );
});
const FilterProgramList = React.memo(({...other}) => {
    const { searchMetaParam,
            searchParam,
            setSearchParam   } = other;

    function getLabelValue(d) {
        const found = searchMetaParam.PROGRAM_LIST.find((item) => item.PROGRAM_ID === d);
        return found ? found.PROGRAM_DESC : null;
    }
    const RemoveItem = (d) => {
        setSearchParam((prevState) => {
            const newList = prevState.PROGRAM_IDS.filter(item => item !== d);
            return {
                ...prevState,
                PROGRAM_IDS: newList,
            };
        });
    };
    useEffect(() => {},[searchParam, setSearchParam]);

    return (
        <>                                        
            {searchParam?.PROGRAM_IDS?.map((item, i) => {
                    return (
                        <div key={`program_list_${item}${i}`}  className={[MainStyle.d_flex, MainStyle.align_items_center, MainStyle.rounded, MainStyle.filter_param_item_border, MainStyle.my_2].join(" ")}>
                            <div className={[MainStyle.mx_2].join(" ")}>
                                <FilterBtnRemoveItem clickAction={() => RemoveItem(item)} />
                            </div>
                            <div className={[].join(" ")}>
                                <span className={[MainStyle.text_body, MainStyle.fs_8].join(" ")}>
                                    {getLabelValue(item)}
                                </span>
                            </div>
                        </div>                       
                    )
                }
            )}
        </>
    );
});

const FilterClassList = React.memo(({...other}) => {
    const { searchMetaParam,
            searchParam,
            setSearchParam   } = other;

    function getLabelValue(d) {
        const found = searchMetaParam.CLASS_LIST.find((item) => item.CLASS_ID === d);
        return found ? found.CLASS_DESC : null;
    }
    const RemoveItem = (d) => {
        setSearchParam((prevState) => {
            const newList = prevState.CLASSES_IDS.filter(item => item !== d);
            return {
                ...prevState,
                CLASSES_IDS: newList,
            };
        });
    };
    useEffect(() => {},[searchParam, setSearchParam]);

    return (
        <>                                        
            {searchParam?.CLASSES_IDS?.map((item, i) => {
                    return (
                        <div key={`class_list_${item}${i}`}  className={[MainStyle.d_flex, MainStyle.align_items_center, MainStyle.rounded, MainStyle.filter_param_item_border, MainStyle.my_2].join(" ")}>
                            <div className={[MainStyle.mx_2].join(" ")}>
                                <FilterBtnRemoveItem clickAction={() => RemoveItem(item)} />
                            </div>
                            <div className={[].join(" ")}>
                                <span className={[MainStyle.text_body, MainStyle.fs_8].join(" ")}>
                                    {getLabelValue(item)}
                                </span>
                            </div>
                        </div>                       
                    )
                }
            )}
        </>
    );
});


const FilterClientList = React.memo(({...other}) => {
    const { searchMetaParam,
            searchParam,
            setSearchParam   } = other;
    
    function getLabelValue(d) {
        const found = searchMetaParam.CLIENT_LIST.find((item) => item.CLIENT_ID === d);
        return found ? found.CLIENT_DESC : null;
    }
    const RemoveItem = (d) => {
        setSearchParam((prevState) => {
            const newList = prevState.CLIENT_IDS.filter(item => item !== d);
            return {
                ...prevState,
                CLIENT_IDS: newList,
            };
        });
    };
    useEffect(() => {},[searchParam, setSearchParam]);

    return (
        <>                                        
            {searchParam?.CLIENT_IDS?.map((item, i) => {
                    return (
                        <div key={`client_list_${item}${i}`}  className={[MainStyle.d_flex, MainStyle.align_items_center, MainStyle.rounded, MainStyle.filter_param_item_border, MainStyle.my_2].join(" ")}>
                            <div className={[MainStyle.mx_2].join(" ")}>
                                <FilterBtnRemoveItem clickAction={() => RemoveItem(item)} />
                            </div>
                            <div className={[].join(" ")}>
                                <span className={[MainStyle.text_body, MainStyle.fs_8].join(" ")}>
                                    {getLabelValue(item)}
                                </span>
                            </div>
                        </div>                        
                    )
                }
            )}
        </>
    );
});
const FilterAcademicAreaList = React.memo(({...other}) => {
    const { searchMetaParam,
            searchParam,
            setSearchParam   } = other;
    
    function getLabelValue(d) {
        const found = searchMetaParam.ACADEMIC_AREA_LIST.find((item) => item.ACADEMIC_AREA_ID === d);
        return found ? found.ACADEMIC_AREA_DESC : null;
    }
    const RemoveItem = (d) => {
        setSearchParam((prevState) => {
            const newList = prevState.ACADEMIC_AREA_IDS.filter(item => item !== d);
            return {
                ...prevState,
                ACADEMIC_AREA_IDS: newList,
            };
        });
    };
    useEffect(() => {},[searchParam, setSearchParam]);

    return (
        <>                                        
            {searchParam?.ACADEMIC_AREA_IDS?.map((item, i) => {
                    return (
                        <div key={`program_list_${item}${i}`}  className={[MainStyle.d_flex, MainStyle.align_items_center, MainStyle.rounded, MainStyle.filter_param_item_border, MainStyle.my_2].join(" ")}>
                            <div className={[MainStyle.mx_2].join(" ")}>
                                <FilterBtnRemoveItem clickAction={() => RemoveItem(item)} />
                            </div>
                            <div className={[].join(" ")}>
                                <span className={[MainStyle.text_body, MainStyle.fs_8].join(" ")}>
                                    {getLabelValue(item)}
                                </span>
                            </div>
                        </div>                        
                    )
                }
            )}
        </>
    );
});
const FilterUsersList = React.memo(({...other}) => {
    const { searchMetaParam,
            searchParam,
            setSearchParam   } = other;
    
    function getLabelValue(d) {
        const found = searchMetaParam.USER_LIST.find((item) => item.USER_ID === d);
        return found ? found.FULL_NAME : null;
    }
    const RemoveItem = (d) => {
        setSearchParam((prevState) => {
            const newList = prevState.USER_IDS.filter(item => item !== d);
            return {
                ...prevState,
                USER_IDS: newList,
            };
        });
    };
    useEffect(() => {},[searchParam, setSearchParam]);

    return (
        <>                                        
            {searchParam?.USER_IDS?.map((item, i) => {
                    return (
                        <div key={`users_list_${item}${i}`}  className={[MainStyle.d_flex, MainStyle.align_items_center, MainStyle.rounded, MainStyle.filter_param_item_border, MainStyle.my_2].join(" ")}>
                            <div className={[MainStyle.mx_2].join(" ")}>
                                <FilterBtnRemoveItem clickAction={() => RemoveItem(item)} />
                            </div>
                            <div className={[].join(" ")}>
                                <span className={[MainStyle.text_body, MainStyle.fs_8].join(" ")}>
                                    {getLabelValue(item)}
                                </span>
                            </div>
                        </div>                        
                    )
                }
            )}
        </>
    );
});
const QuestionList = React.memo(({...other}) => {
    const { searchMetaParam,
            searchParam,
            setSearchParam   } = other;
    
    function getLabelValue(d) {
        const found = searchMetaParam.QUESTION_LIST.find((item) => item.QUESTION_ID === d);
        return found ? found.QUESTION_DESC : null;
    }
    const RemoveItem = (d) => {
        setSearchParam((prevState) => {
            const newList = prevState.QUESTION_IDS.filter(item => item !== d);
            return {
                ...prevState,
                QUESTION_IDS: newList,
            };
        });
    };
    useEffect(() => {},[searchParam, setSearchParam]);

    return (
        <>                                        
            {searchParam?.QUESTION_IDS?.map((item, i) => {
                    return (
                        <div key={`question_list_${item}${i}`}  className={[MainStyle.d_flex, MainStyle.align_items_center, MainStyle.rounded, MainStyle.filter_param_item_border, MainStyle.my_2].join(" ")}>
                            <div className={[MainStyle.mx_2].join(" ")}>
                                <FilterBtnRemoveItem clickAction={() => RemoveItem(item)} />
                            </div>
                            <div className={[].join(" ")}>
                                <span className={[MainStyle.text_body, MainStyle.fs_8].join(" ")}>
                                    {getLabelValue(item)}
                                </span>
                            </div>
                        </div>                        
                    )
                }
            )}
        </>
    );
});
const FilterOptions = React.memo(({...props}) => {
    const { searchMetaParam,
            searchParam,
            setSearchParam  }      = props;

    useEffect(() => {},[searchMetaParam, searchParam]);
    
    return (
        searchMetaParam ? (
            <React.Fragment>
                {/*         School        */}
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg}>
                        <div className={MainStyle.border_bottom}>
                            <div className={MainStyle.my_2}>
                                <div className={MainStyle.row}>
                                    <div className={MainStyle.col_lg}>
                                        <div className={[MainStyle.mx_3].join(" ")}>
                                            <span className={[MainStyle.text_body, MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>
                                                {GetLabel(appLang, 318)}
                                            </span>
                                            <DropdownList
                                                value={null}
                                                placeholder={GetLabel(appLang, 379)}
                                                listOfItems={ 
                                                    searchMetaParam?.SCHOOL_LIST?.map((i) => (
                                                            {value: i.SCHOOL_ID, label: i.SCHOOL_DESC}
                                                        ))
                                                }
                                                style={{ width: "100%" }}
                                                className={[MainStyle.mt_2].join(" ")}
                                                onChange={(event) => {
                                                    if (searchParam.SCHOOL_IDS.some((i) => i === event)) {
                                                        return;
                                                    }
                                                    else {
                                                        setSearchParam(prevState => ({
                                                            ...prevState,
                                                            SCHOOL_IDS: [...prevState.SCHOOL_IDS, event]
                                                        }));
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className={MainStyle.row}>
                                    <div className={MainStyle.col_lg}>
                                        <div className={[MainStyle.mx_3].join(" ")}>
                                            <FilterSchoolList searchMetaParam={searchMetaParam} searchParam={searchParam}  setSearchParam={setSearchParam}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*          Area         */}
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg}>
                        <div className={MainStyle.border_bottom}>
                            <div className={MainStyle.my_2}>
                                <div className={MainStyle.row}>
                                    <div className={MainStyle.col_lg}>
                                        <div className={[MainStyle.mx_3].join(" ")}>
                                            <span className={[MainStyle.text_body, MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>
                                                {GetLabel(appLang, 319)}
                                            </span>
                                            <DropdownList
                                                value={null}
                                                placeholder={GetLabel(appLang, 380)}
                                                listOfItems={ 
                                                    searchMetaParam?.AREA_LIST?.map((i) => (
                                                            {value: i.AREA_ID, label: i.AREA_DESC}
                                                        ))
                                                }
                                                style={{ width: "100%" }}
                                                className={[MainStyle.mt_2].join(" ")}
                                                onChange={(event) => {
                                                    if (searchParam.AREA_IDS.some((i) => i === event)) {
                                                        return;
                                                    }
                                                    else {
                                                        setSearchParam(prevState => ({
                                                            ...prevState,
                                                            AREA_IDS: [...prevState.AREA_IDS, event]
                                                        }));
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className={MainStyle.row}>
                                    <div className={MainStyle.col_lg}>
                                        <div className={[MainStyle.mx_3].join(" ")}>
                                            <FilterAreaList searchMetaParam={searchMetaParam} searchParam={searchParam}  setSearchParam={setSearchParam}/>
                                        </div>
                                    </div>
                                </div>
                            </div>  
                        </div>
                    </div>
                </div>
                {/*        Program        */}
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg}>
                        <div className={MainStyle.border_bottom}>
                            <div className={MainStyle.my_2}>
                                <div className={MainStyle.row}>
                                    <div className={MainStyle.col_lg}>
                                        <div className={[MainStyle.mx_3].join(" ")}>
                                            <span className={[MainStyle.text_body, MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>
                                                {GetLabel(appLang, 321)}
                                            </span>
                                            <DropdownList
                                                value={null}
                                                placeholder={GetLabel(appLang, 381)}
                                                listOfItems={ 
                                                    searchMetaParam?.PROGRAM_LIST?.map((i) => (
                                                            {value: i.PROGRAM_ID, label: i.PROGRAM_DESC}
                                                        ))
                                                }
                                                style={{ width: "100%" }}
                                                className={[MainStyle.mt_2].join(" ")}
                                                onChange={(event) => {
                                                    if (searchParam.PROGRAM_IDS.some((i) => i === event)) {
                                                        return;
                                                    }
                                                    else {
                                                        setSearchParam(prevState => ({
                                                            ...prevState,
                                                            PROGRAM_IDS: [...prevState.PROGRAM_IDS, event]
                                                        }));
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className={MainStyle.row}>
                                    <div className={MainStyle.col_lg}>
                                        <div className={[MainStyle.mx_3].join(" ")}>
                                            <FilterProgramList searchMetaParam={searchMetaParam} searchParam={searchParam}  setSearchParam={setSearchParam}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/*        Class        */}
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg}>
                        <div className={MainStyle.border_bottom}>
                            <div className={MainStyle.my_2}>
                                <div className={MainStyle.row}>
                                    <div className={MainStyle.col_lg}>
                                        <div className={[MainStyle.mx_3].join(" ")}>
                                            <span className={[MainStyle.text_body, MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>
                                                {GetLabel(appLang, 661)}
                                            </span>
                                            <DropdownList
                                                value={null}
                                                placeholder={GetLabel(appLang, 690)}
                                                listOfItems={ 
                                                    searchMetaParam?.CLASS_LIST?.map((i) => (
                                                            {value: i.CLASS_ID, label: i.CLASS_DESC}
                                                        ))
                                                }
                                                style={{ width: "100%" }}
                                                className={[MainStyle.mt_2].join(" ")}
                                                onChange={(event) => {
                                                    if (searchParam.CLASSES_IDS.some((i) => i === event)) {
                                                        return;
                                                    }
                                                    else {
                                                        setSearchParam(prevState => ({
                                                            ...prevState,
                                                            CLASSES_IDS: [...prevState.CLASSES_IDS, event]
                                                        }));
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className={MainStyle.row}>
                                    <div className={MainStyle.col_lg}>
                                        <div className={[MainStyle.mx_3].join(" ")}>
                                            <FilterClassList searchMetaParam={searchMetaParam} searchParam={searchParam}  setSearchParam={setSearchParam}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/*        Client         */}
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg}>
                        <div className={MainStyle.border_bottom}>
                            <div className={MainStyle.my_2}>
                                <div className={MainStyle.row}>
                                    <div className={MainStyle.col_lg}>
                                        <div className={[MainStyle.mx_3].join(" ")}>
                                            <span className={[MainStyle.text_body, MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>
                                                {GetLabel(appLang, 322)}
                                            </span>
                                            <DropdownList
                                                value={null}
                                                placeholder={GetLabel(appLang, 382)}
                                                listOfItems={ 
                                                    searchMetaParam?.CLIENT_LIST?.map((i) => (
                                                            {value: i.CLIENT_ID, label: i.CLIENT_DESC}
                                                        ))
                                                }
                                                style={{ width: "100%" }}
                                                className={[MainStyle.mt_2].join(" ")}
                                                onChange={(event) => {
                                                    if (searchParam.CLIENT_IDS.some((i) => i === event)) {
                                                        return;
                                                    }
                                                    else {
                                                        setSearchParam(prevState => ({
                                                            ...prevState,
                                                            CLIENT_IDS: [...prevState.CLIENT_IDS, event]
                                                        }));
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className={MainStyle.row}>
                                    <div className={MainStyle.col_lg}>
                                        <div className={[MainStyle.mx_3].join(" ")}>
                                            <FilterClientList searchMetaParam={searchMetaParam} searchParam={searchParam}  setSearchParam={setSearchParam}/>
                                        </div>
                                    </div>
                                </div>
                            </div>  
                        </div>
                    </div>
                </div>
                {/*     Academic Area     */}
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg}>
                        <div className={MainStyle.border_bottom}>
                            <div className={MainStyle.my_2}>
                                <div className={MainStyle.row}>
                                    <div className={MainStyle.col_lg}>
                                        <div className={[MainStyle.mx_3].join(" ")}>
                                            <span className={[MainStyle.text_body, MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>
                                                {GetLabel(appLang, 323)}
                                            </span>
                                            <DropdownList
                                                value={null}
                                                placeholder={GetLabel(appLang, 522)}
                                                listOfItems={ 
                                                    searchMetaParam?.ACADEMIC_AREA_LIST?.map((i) => (
                                                            {value: i.ACADEMIC_AREA_ID, label: i.ACADEMIC_AREA_DESC}
                                                        ))
                                                }
                                                style={{ width: "100%" }}
                                                className={[MainStyle.mt_2].join(" ")}
                                                onChange={(event) => {
                                                    if (searchParam.ACADEMIC_AREA_IDS.some((i) => i === event)) {
                                                        return;
                                                    }
                                                    else {
                                                        setSearchParam(prevState => ({
                                                            ...prevState,
                                                            ACADEMIC_AREA_IDS: [...prevState.ACADEMIC_AREA_IDS, event]
                                                        }));
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className={MainStyle.row}>
                                    <div className={MainStyle.col_lg}>
                                        <div className={[MainStyle.mx_3].join(" ")}>
                                            <FilterAcademicAreaList searchMetaParam={searchMetaParam} searchParam={searchParam}  setSearchParam={setSearchParam}/>
                                        </div>
                                    </div>
                                </div>
                            </div>  
                        </div>
                    </div>
                </div>
                {/*         Users         */}
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg}>
                        <div className={MainStyle.border_bottom}>
                            <div className={MainStyle.my_2}>
                                <div className={MainStyle.row}>
                                    <div className={MainStyle.col_lg}>
                                        <div className={[MainStyle.mx_3].join(" ")}>
                                            <span className={[MainStyle.text_body, MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>
                                                {GetLabel(appLang, 81)}
                                            </span>
                                            <DropdownList
                                                value={null}
                                                placeholder={GetLabel(appLang, 286)}
                                                listOfItems={ 
                                                    searchMetaParam?.USER_LIST?.map((i) => (
                                                            {value: i.USER_ID, label: i.FULL_NAME}
                                                        ))
                                                }
                                                style={{ width: "100%" }}
                                                className={[MainStyle.mt_2].join(" ")}
                                                onChange={(event) => {
                                                    if (searchParam.USER_IDS.some((i) => i === event)) {
                                                        return;
                                                    }
                                                    else {
                                                        setSearchParam(prevState => ({
                                                            ...prevState,
                                                            USER_IDS: [...prevState.USER_IDS, event]
                                                        }));
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className={MainStyle.row}>
                                    <div className={MainStyle.col_lg}>
                                        <div className={[MainStyle.mx_3].join(" ")}>
                                            <FilterUsersList searchMetaParam={searchMetaParam} searchParam={searchParam}  setSearchParam={setSearchParam}/>
                                        </div>
                                    </div>
                                </div>
                            </div>  
                        </div>
                    </div>
                </div>        
                {/*         Question         */}
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg}>
                        <div className={MainStyle.border_bottom}>
                            <div className={MainStyle.my_2}>
                                <div className={MainStyle.row}>
                                    <div className={MainStyle.col_lg}>
                                        <div className={[MainStyle.mx_3].join(" ")}>
                                            <span className={[MainStyle.text_body, MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>
                                                {GetLabel(appLang, 79)}
                                            </span>
                                            <DropdownList
                                                value={null}
                                                placeholder={GetLabel(appLang, 208)}
                                                listOfItems={ 
                                                    searchMetaParam?.QUESTION_LIST?.map((i) => (
                                                            {value: i.QUESTION_ID, label: i.QUESTION_DESC}
                                                        ))
                                                }
                                                style={{ width: "100%" }}
                                                className={[MainStyle.mt_2].join(" ")}
                                                onChange={(event) => {
                                                    if (searchParam.QUESTION_IDS.some((i) => i === event)) {
                                                        return;
                                                    }
                                                    else {
                                                        setSearchParam(prevState => ({
                                                            ...prevState,
                                                            QUESTION_IDS: [...prevState.QUESTION_IDS, event]
                                                        }));
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className={MainStyle.row}>
                                    <div className={MainStyle.col_lg}>
                                        <div className={[MainStyle.mx_3].join(" ")}>
                                            <QuestionList searchMetaParam={searchMetaParam} searchParam={searchParam}  setSearchParam={setSearchParam}/>
                                        </div>
                                    </div>
                                </div>
                            </div>  
                        </div>
                    </div>
                </div>                                       
                {/*         DT Init       */}         
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg}>
                        <div className={MainStyle.border_bottom}>
                            <div className={[MainStyle.m_3].join(" ")}>
                                <span className={[MainStyle.my_2, MainStyle.text_body, MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>
                                    {GetLabel(appLang, 523)}
                                </span>                      
                                <DatePicker
                                    value={InitDateFromIsoString(searchParam.DT_INIT)}
                                    placeholder={GetLabel(appLang, 487)}
                                    style={{ width: "100%" }}
                                    className={[MainStyle.mt_2].join(" ")}
                                    onChange={(date) => {
                                        setSearchParam(prev => {
                                            return({
                                                ...prev,
                                                DT_INIT: InitDateToIsoString(date),
                                            });
                                        });
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                {/*         DT Fin        */}
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg}>
                        <div className={MainStyle.border_bottom}>
                            <div className={[MainStyle.m_3].join(" ")}>
                                <span className={[MainStyle.my_2, MainStyle.text_body, MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>
                                    {GetLabel(appLang, 524)}
                                </span>
                                <DatePicker
                                    value={DateFromIsoString(searchParam.DT_FN)}
                                    placeholder={GetLabel(appLang, 488)}
                                    style={{ width: "100%" }}
                                    className={[MainStyle.mt_2].join(" ")}
                                    onChange={(date) => {
                                        setSearchParam(prev => {
                                            return({
                                                ...prev,
                                                DT_FN: InitDateToIsoString(date),
                                            });
                                        });
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg}>
                        <div className={[MainStyle.my_2, MainStyle.mx_3].join(" ")}>
                            <button
                                style={{width: '100%'}}
                                className={[MainStyle.btn_vanilla, 
                                            MainStyle.rounded_3, 
                                            MainStyle.border, 
                                            MainStyle.shadow_sm, 
                                            MainStyle.fs_6,
                                            MainStyle.text_body,
                                            MainStyle.py_3,
                                            MainStyle.px_3].join(" ")}
                                onClick={async () => {
                                    setSearchParam(prev => {
                                        return({
                                            ...prev,
                                            DT_INIT: DateToIsoString(setDefaultInitDate()),
                                            DT_FN: DateToIsoString(setDefaultFinalDate()),
                                            STATUS_IDS        : [4],
                                            SCHOOL_IDS        : [],
                                            AREA_IDS          : [],
                                            PROGRAM_IDS       : [],
                                            CLASSES_IDS       : [],
                                            CLIENT_IDS        : [],
                                            ACADEMIC_AREA_IDS : [],
                                            USER_IDS          : [],
                                            QUESTION_IDS      : []
                                        });
                                    });
                                }}
                            >
                                {GetLabel(appLang, 239)}
                            </button>
                        </div>
                    </div>                            
                </div>
            </React.Fragment>

        )
        :
        (
            <div className={MainStyle.row}>
                <div className={MainStyle.col_lg}>
                    <div style={{height: '10rem'}} className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.my_5].join(" ")}>
                        <div style={{zIndex: "1"}} className={[MainStyle.small_loading_circle].join(" ")}/>
                    </div>
                </div>
            </div>
        )
    );

});

const Drawer = React.memo(({children}) => {
    const [ expanded, setExpanded] = useState(false);
    const [ height,   setHeight]   = useState(0);
    const [ overFlow, setOverFlow] = useState("hidden");
    const intervalRef              = useRef(null);

    const handleClick = () => {
        if (intervalRef.current) return;

        if (!expanded) {
          setExpanded(true);
          intervalRef.current = setInterval(() => {
            setHeight(prev => {
              if (prev >= 100) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
                return 100;
              }
              return prev + 1;
            });
            setOverFlow("scroll");
          }, 5);
        } else {
          intervalRef.current = setInterval(() => {
            setHeight(prev => {
              if (prev <= 0) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
                setExpanded(false); // Close only after animation ends
                return 0;
              }
              return prev - 1;
            });
            setOverFlow("hidden");
          }, 5);
        }
    };
    return (
        <>        
            { 
                expanded ?
                    <>
                        <div className={[MainStyle.bg_card_item, MainStyle.shadow_sm, MainStyle.border, MainStyle.rounded].join(" ")}>
                            <div className={[MainStyle.d_flex, MainStyle.bg_header_item, MainStyle.rounded_top].join(" ")}>
                                    <div className={[ MainStyle.align_self_center]}>
                                        <span className={[MainStyle.mx_3, MainStyle.text_white, MainStyle.fw_semibold].join(" ")}>
                                            {GetLabel(appLang, 547)}
                                        </span> 
                                    </div>
                                    <div className={[MainStyle.ms_auto].join(" ")}>
                                        <div 
                                            onClick={() => {handleClick();}}
                                            className={[MainStyle.shadow_sm, MainStyle.rounded_top, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_3, MainStyle.ms_1].join(" ")}>
                                            <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                                                <path d="M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"/>
                                            </svg>
                                        </div>
                                    </div>
                            </div>
                            <div 
                                style={{
                                   height: `${Math.floor(height / 2.0)}rem`,
                                   overflowY: `${overFlow}`,
                                   transition: 'height 0.1s linear',
                                 }}
                                className={MainStyle.bg_theme}
                            >
                                {children}
                            </div>
                        </div>
                    </>
                :
                    <>
                        <div className={[MainStyle.bg_card_item, MainStyle.shadow_sm, MainStyle.border, MainStyle.rounded].join(" ")}>
                            <div className={[MainStyle.d_flex, MainStyle.bg_card_item, MainStyle.rounded_top].join(" ")}>
                                <div className={[ MainStyle.align_self_center]}>
                                    <span className={[MainStyle.mx_3, MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>
                                        {GetLabel(appLang, 547)}
                                    </span> 
                                </div>
                                <div className={[MainStyle.ms_auto].join(" ")}>
                                    <div 
                                        onClick={() => {handleClick();}}
                                        className={[MainStyle.shadow_sm, MainStyle.rounded_top_end_bottom_end_1, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_3, MainStyle.ms_1].join(" ")}>
                                        <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                                            <path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <div 
                                style={{
                                   height: `${Math.floor(height / 5.0)}rem`,
                                   overflowY: `${overFlow}`,
                                   transition: 'height 0.1s linear',
                                }}
                            >
                            </div>
                        </div>
                    </>
            }
        </>
    );

});


// #endregion

function downloadExcelFromBase64(base64) {
    const byteCharacters    = atob(base64);
    const byteNumbers       = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    const blob = new Blob([byteArray], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    const blobUrl = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = `Survey_Exported_Sheet_${Date.now()}_${Math.floor(Math.random() * 32672)}.xlsx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(blobUrl);
}

const ExportData = React.memo(({...other}) => {
    const { setScreen,
            searchMetaParam,                    } = other;
    const [ searchParam,        setSearchParam  ] = useState(blank_search_param_obj);            
    const [ fileData,           setFileData     ] = useState(null);
    const { showInfoMessage                     } = useInfoMsgModal();
    const { showLoader,         hideLoader      } = useLoader();
    const { showToastMessage                    } = useToastMessage();
    
    async function GetFileData(obj) {
        if (!compareInitFinDate(searchParam.DT_INIT, searchParam.DT_FN)) {
            showInfoMessage({header: GetLabel(appLang, 54), message: GetLabel(appLang, 230)});
            return;
        }
        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
        let data = await getData(obj);
        if (data) {
            if (data?.status?.statusCode == 0) {
                data = data.response.content;
                setFileData(data.DATA); 
                hideLoader();
                showToastMessage({
                    'header': GetLabel(appLang, 54), 
                    'message': GetLabel(appLang, 538)
                });
            }
            else {
                hideLoader();
                showInfoMessage({'header': GetLabel(appLang, 107), 'message': data.status.message});
            }
        }
        else {
            hideLoader();
            showInfoMessage({'header': GetLabel(appLang, 107), 'message': data.status.message});
        }
    }

    useEffect(() => {},[searchMetaParam, setScreen]);

    return (
        <React.Fragment>
            <DefaultPadding/>
            <div className={[MainStyle.bg_card, MainStyle.shadow, MainStyle.border, MainStyle.rounded].join(" ")}>
                <DefaultPadding/>
                <div className={MainStyle.mx_3}>
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg}>
                                <Drawer>
                                    <FilterOptions 
                                        searchMetaParam={searchMetaParam}
                                        searchParam={searchParam}
                                        setSearchParam={setSearchParam}
                                    />
                                </Drawer>
                        </div>
                    </div>
                    <DefaultPadding/>
                    <div className={MainStyle.row}>
                        {fileData && (
                            <React.Fragment>
                                <div className={MainStyle.col_lg}>
                                    <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.align_items_center, MainStyle.my_3].join(" ")}>
                                        <button onClick={() => {
                                                    downloadExcelFromBase64(fileData);
                                                    showToastMessage({
                                                        'header': GetLabel(appLang, 54), 
                                                        'message': GetLabel(appLang, 552)
                                                    });                                                    
                                                }}
                                                style={{ width: '100%' }}
                                                className={[MainStyle.text_center,
                                                            MainStyle.btn_blue, 
                                                            MainStyle.border, 
                                                            MainStyle.shadow_sm, 
                                                            MainStyle.fs_6,
                                                            MainStyle.text_white,
                                                            MainStyle.rounded_3].join(" ")} 
                                        >
                                            <div className={[MainStyle.my_3].join(" ")}>
                                                <span>{GetLabel(appLang, 560)}</span>
                                            </div>
                                        </button>
                                    </div>
                                </div>
                                <div className={MainStyle.col_lg_1}/>
                            </React.Fragment>
                        )}                        
                        <div className={MainStyle.col_lg}>
                            <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.align_items_center, MainStyle.my_3].join(" ")}>
                                <button onClick={() => {GetFileData(searchParam);}}
                                        style={{ width: '100%' }}
                                        className={[MainStyle.text_center,
                                                    MainStyle.btn_blue, 
                                                    MainStyle.border, 
                                                    MainStyle.shadow_sm, 
                                                    MainStyle.fs_6,
                                                    MainStyle.text_white,
                                                    MainStyle.rounded_3].join(" ")} 
                                >
                                    <div className={[MainStyle.my_3].join(" ")}>
                                        <span>{GetLabel(appLang, 554)}</span>
                                    </div>
                                </button>                                
                            </div>
                        </div>
                    </div>
                </div>
                <DefaultPadding/>
            </div>
        </React.Fragment>
    );
});

export const Report_3_Page = () => {
    const [ screenType,     setScreenType       ]   = useState(1);
    const navigate                                  = useNavigate();
    const [ searchMetaParam, setSearchMetaParam ]   = useState(null);
    
    useEffect(() => {
        if (!Heimdall([19])) {
            navigate('/home');
        }
        else {
            SetLastFeature(19);
        }        
        const fetchFilterData = async () => {
            let data = await getFilterMeta();
            if (data) {
                if (data?.status?.statusCode == 0) {
                    data = data.response.content;
                    setSearchMetaParam(data);
                }
                else {
                    setSearchMetaParam(blank_meta_param_obj);
                }
            }
            else {
                setSearchMetaParam(blank_meta_param_obj);
            }
        };
        fetchFilterData();
    }, [screenType]);
    
    const ExitWrapper = ({children, onClick }) => {
        return(
            <div style={{   position: 'fixed', 
                            bottom: '0', 
                            //marginBottom: '1rem', 
                            cursor: 'pointer', 
                            zIndex: '10',
                            width: '100%'
                        }}
                  onClick={onClick}
            >
                {children}
            </div>
        );
    };
    const ExitContent = () => {
        return (
            <div className={[MainStyle.d_flex, MainStyle.align_items_center, MainStyle.justify_content_center, MainStyle.shadow, MainStyle.border, MainStyle.bg_card_item].join(" ")}>
                <svg viewBox="0 0 512 512"
                        xmlns="http://www.w3.org/2000/svg" 
                        className={[MainStyle.small_ico_person_door, MainStyle.m_2].join(" ")}
                >
                    <path d="M355.022,115.897c22.422,0,40.603-18.19,40.603-40.616c0-22.427-18.181-40.608-40.603-40.608 c-22.434,0-40.616,18.182-40.616,40.608C314.406,97.707,332.588,115.897,355.022,115.897z"/>
                    <path d="M509.402,232.445l-26.925-40.501c-6.543-9.57-15.22-17.486-25.33-23.155l-52.81-29.574 c-9.676-4.524-16.996-7.402-26.189-6.159l-25.268,3.436c-9.422,1.275-18.01,6.077-24.037,13.429l-48.096,51.183l-44.055,16.244 c-8.346,3.075-12.825,12.137-10.186,20.627l0.204,0.654c2.593,8.358,11.196,13.29,19.715,11.327l35.901-8.284 c8.952-2.07,17.458-5.758,25.072-10.894l24.97-16.783l8.816,67.033c0.647,4.916-0.343,9.913-2.822,14.214l-74.758,129.848 c-5.333,9.242-2.176,21.068,7.05,26.45l0.642,0.376c8.735,5.087,19.908,2.633,25.69-5.643l83.558-119.534l25.322,50.537 c1.873,3.738,4.351,7.132,7.336,10.044l56.164,54.92c7.091,6.928,18.305,7.23,25.747,0.712l0.9-0.786 c3.819-3.345,6.134-8.073,6.436-13.135c0.302-5.055-1.431-10.036-4.826-13.806l-47.421-52.818L424.44,269.16l-0.09,0.082 l-7.394-72.947l26.115,11.753l41.752,43.945c5.251,5.537,13.757,6.429,20.038,2.094l0.426-0.295 C512.256,248.999,514.096,239.495,509.402,232.445z"></path> 
                    <polygon points="129.123,101.06 43.287,42.435 262.74,42.435 262.74,8.934 0,8.934 0,444.44 43.287,444.44 129.123,503.066 129.123,486.315 129.123,444.44 233.8,444.44 233.8,410.94 129.123,410.94"/>
                </svg>
                <span className={[  MainStyle.fs_5,
                                    MainStyle.text_body  ].join(" ")}>
                    {GetLabel(null, 168)}
                </span>   
            </div>
        );
    };

    return (
        <React.Fragment>
        {
        screenType == 1? 
            <React.Fragment>
                <DefaultPadding/>
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_12}>
                        <div className={[MainStyle.mx_3].join(" ")}>
                            <ExportData 
                                searchMetaParam={searchMetaParam}
                                setScreen={setScreenType}
                            />
                        </div>
                    </div>
                </div>
                <DefaultPadding/>
            </React.Fragment>
        : 
            null
        }
        </React.Fragment>
    );
};